"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsEncryption = void 0;
const utilsFile_1 = require("./utilsFile");
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsEncryption {
    constructor() {
        this.fileUtil = new utilsFile_1.UtilsFile();
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
    }
    /**
     * EncryptDatabase
     * @param pathDB
     * @param password
     */
    async encryptDatabase(pathDB, password) {
        const msg = 'EncryptDatabase: ';
        const retB = this.fileUtil.isPathExists(pathDB);
        if (retB) {
            try {
                const mDB = await this.sqliteUtil.openOrCreateDatabase(pathDB, '', false);
                this.sqliteUtil.pragmaReKey(mDB, '', password);
                this.sqliteUtil.closeDB(mDB);
                return Promise.resolve();
            }
            catch (err) {
                return Promise.reject(new Error(`${msg} ${err.message} `));
            }
        }
        else {
            return Promise.reject(new Error(`${msg}file path ${pathDB} ` + 'does not exist'));
        }
    }
    async decryptDatabase(pathDB, password) {
        const msg = 'DecryptDatabase: ';
        const retB = this.fileUtil.isPathExists(pathDB);
        if (retB) {
            try {
                const mDB = await this.sqliteUtil.openOrCreateDatabase(pathDB, password, false);
                this.sqliteUtil.pragmaReKey(mDB, password, '');
                this.sqliteUtil.closeDB(mDB);
                return Promise.resolve();
            }
            catch (err) {
                return Promise.reject(new Error(`${msg} ${err.message} `));
            }
        }
        else {
            return Promise.reject(new Error(`${msg}file path ${pathDB} ` + 'does not exist'));
        }
    }
}
exports.UtilsEncryption = UtilsEncryption;
//# sourceMappingURL=utilsEncryption.js.map